'use strict'

var powers = 0

exports.boolean = increment()
exports.booleanish = increment()
exports.overloadedBoolean = increment()
exports.number = increment()
exports.spaceSeparated = increment()
exports.commaSeparated = increment()
exports.commaOrSpaceSeparated = increment()

function increment() {
  return Math.pow(2, ++powers)
}



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/~/property-information/lib/util/types.js
// module id = 48
// module chunks = 35783957827783 204390864267482 254791781388126